module.exports = __webpack_public_path__ + "img/icon-vegetarian.fe4039eb.svg";